<div
  *ngIf="{ countries: availableCountries$ | async, context: context$ | async } as siteContext"
  class="eb-country-selection"
  [ngClass]="{ open: (isOpen | async) }"
>
  <div class="eb-country-selection__country-dialog-header">
    <div>
      <h4>{{ 'siteContextSelector.countryDialog.title' | cxTranslate }}</h4>
      <h5>{{ 'siteContextSelector.countryDialog.caption' | cxTranslate }}</h5>
    </div>
    <cx-icon
      class="eb-country-selection__close-country-dialog"
      type="CLOSE"
      (click)="closeDialog()"
    ></cx-icon>
  </div>
  <div class="eb-country-selection__country-dialog-content">
    <div *ngFor="let country of siteContext.countries" class="eb-country-selection__country">
      <img
        *ngIf="country.countryIcon?.url"
        [src]="getImageUrl(country.countryIcon?.url)"
        [alt]="country?.countryIcon?.code"
        loading="lazy"
      />
      <div>
        <label>{{ country?.countryName }}</label>
        <a *ngIf="country.linkTarget" [href]="country.linkTarget" target="_blank">{{
          country.linkTitle
        }}</a>
        <div
          *ngIf="getMatchingContext(country, siteContext.context) as countryContext"
          class="eb-country-selection__language"
        >
          <label role="link" *ngFor="let item of countryContext?.languages">
            <input
              type="radio"
              (click)="setActiveContext(countryContext, item.isocode)"
              [value]="item.isocode"
              [attr.checked]="
                (activeLanguage$ | async) === item.isocode &&
                (siteContext.context.activeContext?.uid === countryContext.uid ||
                  siteContext.context.activeContext?.uid === countryContext.cmsSite)
              "
            />
            <span class="label" [attr.data-cy]="country.uid + '_' + item.isocode">{{
              item.nativeName
            }}</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
